import { MK_CSS, MarketingNav, MarketingFooter, useMkNav, ArrowRight } from "./MarketingChrome";

const CSS = `
.ap-check { list-style:none; display:flex; flex-direction:column; gap:16px; margin:0; padding:0; }
.ap-check li { display:flex; align-items:flex-start; gap:12px; font-size:16px; line-height:1.5; }
.ap-check svg { flex:0 0 auto; margin-top:2px; }
.ap-story h2 { margin-bottom:24px; font-size:clamp(34px,5vw,52px); }
.ap-story .lead { font-size:18px; line-height:1.5; margin-bottom:32px; }
.ap-story-actions { margin-top:32px; display:flex; flex-wrap:wrap; align-items:center; gap:16px; }
.ap-img43 { width:100%; aspect-ratio:4/3; }

.ap-stats { display:grid; grid-template-columns:0.6fr 1fr; gap:32px; align-items:stretch; }
.ap-stat-col { display:flex; flex-direction:column; gap:32px; }
.ap-stat { display:flex; flex-direction:column; background:var(--panel); border-radius:8px; padding:32px; }
.ap-stat h3 { margin-bottom:16px; font-size:56px; }
.ap-stat h4 { margin-bottom:8px; font-size:22px; }
.ap-stat p { font-size:16px; line-height:1.5; color:var(--muted); }
.ap-stat-img { width:100%; height:100%; min-height:320px; }

.ap-team { display:grid; grid-template-columns:repeat(2,1fr); gap:48px 32px; max-width:760px; margin:0 auto; }
.ap-member { display:flex; flex-direction:column; text-align:center; }
.ap-avatar { width:100%; aspect-ratio:1/1; border-radius:8px; margin-bottom:24px; display:grid; place-items:center; font-family:"Lexend Deca",sans-serif; font-size:44px; color:#fff; }
.ap-member h4 { font-size:22px; }
.ap-member .role { margin-bottom:12px; font-size:16px; color:var(--muted); }
.ap-member .bio { font-size:16px; line-height:1.5; }
.ap-socials { margin-top:20px; display:flex; justify-content:center; gap:16px; }
.ap-socials a { display:inline-flex; color:var(--ink); cursor:pointer; }
.ap-hiring { margin:80px auto 0; max-width:448px; text-align:center; }
.ap-hiring h3 { margin-bottom:12px; font-size:36px; }
.ap-hiring p { font-size:18px; line-height:1.5; }

.ap-awards { padding:80px 5%; background:var(--cream); }
.ap-awards .inner { max-width:1280px; margin:0 auto; text-align:center; }
.ap-awards h3 { margin-bottom:48px; font-size:22px; font-weight:400; }
.ap-award-row { display:flex; flex-wrap:wrap; align-items:center; justify-content:center; gap:48px 64px; }
.ap-award { display:inline-flex; align-items:center; gap:10px; opacity:.7; font-size:24px; font-weight:600; letter-spacing:-.02em; }

@media (max-width:900px){ .ap-stats { grid-template-columns:1fr; } }
@media (max-width:560px){ .ap-team { grid-template-columns:1fr; } }
`;

const CheckIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 13l4 4L19 7" stroke="#607840" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
);

const SocialIcons = () => (
  <div className="ap-socials">
    <a href="#" aria-label="LinkedIn"><svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M6.94 5a2 2 0 11-4 0 2 2 0 014 0zM3.5 8.5h3v12h-3v-12zM9 8.5h2.87v1.64h.04c.4-.76 1.38-1.56 2.84-1.56 3.04 0 3.6 2 3.6 4.6v6.32h-3v-5.6c0-1.34-.02-3.06-1.87-3.06-1.87 0-2.15 1.46-2.15 2.96v5.7H9v-11z" /></svg></a>
    <a href="#" aria-label="X"><svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M18.9 2H22l-7 8 8.2 12H17l-5-7.3L6.3 22H3l7.5-8.6L2.6 2H10l4.5 6.6L18.9 2z" /></svg></a>
    <a href="#" aria-label="Website"><svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6.6 5.9a8.2 8.2 0 011.86 5.06c-.27-.05-3-.6-5.74-.26-.06-.15-.12-.3-.18-.45-.17-.4-.36-.8-.55-1.18 3.03-1.24 4.4-3 4.61-3.17zm-1.15-1.07c-.18.25-1.42 1.9-4.34 3-1.34-2.47-2.83-4.5-3.06-4.8a8.2 8.2 0 017.4 1.8zM8.5 4.7c.22.3 1.68 2.32 3.04 4.74-3.82 1-7.19 1-7.55.99A8.22 8.22 0 018.5 4.7zM3.83 12v-.26c.35.01 4.31.06 8.39-1.16.24.46.46.93.66 1.4l-.32.1c-4.2 1.36-6.44 5.06-6.63 5.38A8.2 8.2 0 013.83 12zm2.35 6.53c.13-.27 1.7-3.3 6.3-4.9 1.6 4.16 2.27 7.65 2.44 8.65a8.2 8.2 0 01-8.74-3.75zm10.06 2.6c-.11-.68-.72-3.98-2.2-8.08 2.58-.41 4.84.26 5.12.35a8.2 8.2 0 01-2.92 7.73z" /></svg></a>
  </div>
);

const TEAM = [
  { initials: "CT", bg: "linear-gradient(135deg,#607840,#3f5229)", name: "Calvin Trinh", role: "Founder & Full-Stack Developer", bio: "Built Bill Lens to kill the midnight invoice grind for small operators and the accountants who support them." },
  { initials: "MN", bg: "linear-gradient(135deg,#8a6a3f,#5c4526)", name: "Minh Nguyen", role: "Developer", bio: "Works across the stack to keep Bill Lens fast and reliable — from invoice capture to the reports you rely on." },
];

export default function AboutPage() {
  const nav = useMkNav();

  return (
    <div className="mk">
      <style>{MK_CSS}</style>
      <style>{CSS}</style>

      <MarketingNav active="about" />

      {/* HEADER */}
      <section className="mk-sec dark">
        <div className="mk-narrow">
          <p className="mk-eyebrow head" style={{ color: "var(--lolive)" }}>About</p>
          <h1>Built for operations</h1>
          <p>We made Bill Lens for the real workflows of restaurants, cafés, bars, and F&amp;B groups. Nothing else.</p>
          <div className="mk-cta-row">
            <button className="mk-btn mk-btn-lg mk-btn-primary" onClick={nav.goSignup}>Start free</button>
            <button className="mk-btn mk-btn-lg mk-btn-glass" onClick={nav.goFeatures}>Features</button>
          </div>
        </div>
      </section>

      {/* STORY */}
      <section className="mk-sec ap-story">
        <div className="mk-wrap mk-two">
          <div>
            <p className="mk-eyebrow head" style={{ color: "var(--olive)" }}>Story</p>
            <h2>We built this for the back of house</h2>
            <p className="lead">We worked the line and we worked the books. We watched good teams bleed margin into a pile of paper invoices and bad data. Bill Lens is the tool we needed then — built to give you clean records and clear spend without adding a single minute of admin.</p>
            <ul className="ap-check">
              <li><CheckIcon /><span>Cleaner invoice records without the manual entry</span></li>
              <li><CheckIcon /><span>Real spend visibility that helps protect your margins</span></li>
              <li><CheckIcon /><span>Faster reporting built for actual kitchen workflows</span></li>
            </ul>
            <div className="ap-story-actions">
              <button className="mk-btn mk-btn-lg mk-btn-soft" onClick={nav.goSignup}>Get started</button>
              <span className="mk-link" style={{ color: "var(--olive)" }} onClick={nav.goPricing}>Pricing <ArrowRight color="#607840" /></span>
            </div>
          </div>
          <div className="mk-img ap-img43"><span className="ph">Kitchen · Team</span></div>
        </div>
      </section>

      {/* STATS */}
      <section className="mk-sec">
        <div className="mk-wrap">
          <div className="mk-center-head" style={{ maxWidth: 512 }}>
            <p className="mk-eyebrow head" style={{ color: "var(--olive)" }}>Impact</p>
            <h2>Numbers that mean something</h2>
            <p>Real metrics from kitchens and bars like yours.</p>
          </div>
          <div className="ap-stats">
            <div className="ap-stat-col">
              <div className="ap-stat"><h3>2M+</h3><h4>Invoices processed cleanly</h4><p>No manual entry. No lost paper.</p></div>
              <div className="ap-stat"><h3>800+</h3><h4>Venues running tighter</h4><p>From single cafés to multi-site groups.</p></div>
              <div className="ap-stat"><h3>15hrs</h3><h4>Saved monthly on reconciliation</h4><p>Time back where it belongs — on the line.</p></div>
            </div>
            <div className="mk-img ap-stat-img"><span className="ph">Venue · Gallery</span></div>
          </div>
        </div>
      </section>

      {/* TEAM */}
      <section className="mk-sec">
        <div className="mk-wrap">
          <div className="mk-center-head" style={{ maxWidth: 512 }}>
            <p className="mk-eyebrow head" style={{ color: "var(--olive)" }}>People</p>
            <h2>Our team</h2>
            <p>We worked the line. We know the weight of a bad invoice.</p>
          </div>
          <div className="ap-team">
            {TEAM.map((m) => (
              <div className="ap-member" key={m.role}>
                <div className="ap-avatar" style={{ background: m.bg }}>{m.initials}</div>
                <h4>{m.name}</h4>
                <p className="role">{m.role}</p>
                <p className="bio">{m.bio}</p>
                <SocialIcons />
              </div>
            ))}
          </div>
          <div className="ap-hiring">
            <h3>We're hiring</h3>
            <p>Come build the tools you wish you had.</p>
            <div style={{ marginTop: 24 }}>
              <a className="mk-btn mk-btn-lg mk-btn-soft" href="mailto:calvintrinh197@gmail.com">Open positions</a>
            </div>
          </div>
        </div>
      </section>

      {/* AWARDS */}
      <div className="ap-awards">
        <div className="inner">
          <h3>Recognized across hospitality tech</h3>
          <div className="ap-award-row">
            {["Webflow", "Relume", "Webflow", "Relume", "Webflow"].map((name, i) => (
              <span className="ap-award" key={i}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="#020202" aria-hidden="true"><path d="M14.5 6.5l-2.7 6.2L9.5 6.5H6.7l-2.3 6.2L2 6.5H0l3.4 11h2.6l2.3-6 2.3 6h2.6L18.6 6.5z" /></svg>
                {name}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <section className="mk-sec dark">
        <div className="mk-narrow">
          <h2>Join the teams running tighter</h2>
          <p>Start with your first invoice today. No setup fees, no training manual required.</p>
          <div className="mk-cta-row">
            <button className="mk-btn mk-btn-lg mk-btn-primary" onClick={nav.goSignup}>Start trial</button>
            <button className="mk-btn mk-btn-lg mk-btn-glass" onClick={nav.goPricing}>See pricing</button>
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}
